/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link, withRouter} from 'react-router-dom'
import TMS from '../BaseComponent/TMS'
import {MDBContainer, MDBRow, MDBCol} from 'mdbreact'
import InputMask from 'react-input-mask'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SinglePicker from '../BaseComponent/singlePicker'
import Select from 'react-select'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import AutoComplete from '../BaseComponent/autocomplete'

class EditTask extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      providers: [],
      arrProviderId: [],
      arrProductId: [],
      serverProviderId: [],
      serverProductId: [],
      providerId: '',
      products: [],
      productId: '',
      activityDate: '',
      sections: [],
      tasks: [],
      timeMinuteMax: '',
      timeMinuteMin: '',
      taskObj: {},
      description: '',
      needProvider: 'notForce',
      needProduct: 'notForce',
      department: [],
      editableCount: '',
      defaultCount: '',
      taskId: '',
      init: true
    }
  }

  changeOrg(e) {
    let name = e.target.name
    let value = e.target.value
    if (value === '') {
      this.setState({
        sections: [],
        departmentId: '',
        sectionId: '',
        taskType: ''
      })
    } else {
      let personId = localStorage.getItem('personId')
      this.setState({
        departmentId: value
      })
      http
        .get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?personId=${personId}&departmentId=${value}`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    }
  }

  changeTaskType(e) {
    let target = e.target
    this.setState({
      timeMinuteMin: target.options[target.selectedIndex].getAttribute('data-timeMinuteMin'),
      timeMinuteMax: target.options[target.selectedIndex].getAttribute('data-timeMinuteMax'),
      needProduct: target.options[target.selectedIndex].getAttribute('data-needProduct'),
      needProvider: target.options[target.selectedIndex].getAttribute('data-needProvider'),
      editableCount: target.options[target.selectedIndex].getAttribute('data-editableCount'),
      defaultCount: target.options[target.selectedIndex].getAttribute('data-defaultCount')
    })
  }

  changeSec(e) {
    let value = e.target.value
    if (value === '') {
      this.setState({
        tasks: []
      })
    } else {
      http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          let res = response.data.object
          res.forEach((item) => {
            if (item.needProduct === 1) {
              item.needProduct = 'force'
            } else if (item.needProduct === 0) {
              item.needProduct = 'notForce'
            } else if (item.needProduct === -1) {
              item.needProduct = 'prevent'
            }

            if (item.needProvider === 1) {
              item.needProvider = 'force'
            } else if (item.needProvider === 0) {
              item.needProvider = 'notForce'
            } else if (item.needProvider === -1) {
              item.needProvider = 'prevent'
            }
          })
          this.setState({
            tasks: res
          })
        } else {
          this.setState({
            tasks: []
          })
        }
      })
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  translateNeedProviderAndProduct = (value) => {
    if (value === 1) {
      return 'force'
    } else if (value === 0) {
      return 'notForce'
    } else if (value === -1) {
      return 'prevent'
    }
  }
  componentDidMount() {
    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    let {id} = this.props.match.params
    http.get(`${TMS.TMS_USER_ACTIVITY_GET}?id=${id}`, {}).then((response) => {
      if (response.data.error === null) {
        let result = response.data.object
        let object = {...result}
        object.timeMinuteOperator = this.convertCount(object.timeMinuteOperator)

        this.setState(
          {
            taskObj: object,
            serverTaskId: response.data.object.taskId,
            serverDepartmentId: response.data.object.departmentId,
            serverSectionId: response.data.object.sectionId,
            taskId: response.data.object.taskId,
            defaultCount: this.convertCount(response.data.object.count),
            description: response.data.object.description,
            needProduct: this.translateNeedProviderAndProduct(response.data.object.taskNeedProduct),
            needProvider: this.translateNeedProviderAndProduct(response.data.object.taskNeedProvider),
            activityDate: this.convertDigit(jMoment(response.data.object.activityDate).format('jYYYY/jMM/jDD')),
            timeMinuteMin: response.data.object.taskTimeMinuteMin,
            timeMinuteMax: response.data.object.taskTimeMinuteMax,
            arrProviderId: response.data.object.providerId,
            init: false
          },
          () => {}
        )

        if (response.data.object.providerId !== null) {
          http
            .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${response.data.object.providerId}`, {
              params: {
                sortByTitle: true
              }
            })
            .then((response) => {
              if (response.data.error === null) {
                var products = response.data.object
                for (let i = 0; i < products.length; i++) {
                  products[i]['value'] = products[i].productId
                  products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
                }
                this.setState({
                  products: response.data.object
                })
              } else {
                this.setState({
                  products: []
                })
              }
            })
        }

        // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{
        //     params: {
        //         sortByTitle: true,
        //         all: true

        //     }
        // }).then((response)=>{
        //     if(response.data.error==null){

        //         var provider = response.data.object;
        //         for (let i = 0; i < provider.length; i++) {
        //             provider[i]['value'] = provider[i].providerId;
        //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
        //         }

        //         this.setState({
        //             providers:response.data.object,
        //         })
        //     }
        //     else{
        //         this.setState({
        //             providers:[]
        //         })
        //     }
        // })
      }

      http.get(`${TMS.TMS_MANAGE_BASE_TASK_LIST}?sectionId=${response.data.object.sectionId}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            tasks: response.data.object
          })
        } else {
          this.setState({
            tasks: []
          })
        }
      })

      http
        .get(
          `${TMS.TMS_MANAGE_BASE_SECTION_LIST}?personId=${localStorage.getItem('personId')}&departmentId=${
            response.data.object.departmentId
          }`,
          {}
        )
        .then((response) => {
          if (response.data.error === null) {
            this.setState({
              sections: response.data.object
            })
          } else {
            this.setState({
              sections: []
            })
          }
        })
    })

    // var personId = localStorage.getItem('personId')
    // http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?personId=${personId}`,{
    // }).then(response=>{
    //     if(response.data.error === null){
    //         this.setState({
    //             sections : response.data.object
    //         })
    //     }
    // })
  }

  componentDidUpdate(prevProps, prevState) {
    // if(prevState.providers !== this.state.providers){
    //     let providerId = this.state.providers.find(item => item.providerId === this.state.taskObj.providerId)
    //     if(providerId){
    //         this.setState({
    //             arrProviderId : providerId,
    //             serverProviderId: providerId
    //         })
    //     }
    //     else{
    //         this.setState({
    //             arrProviderId : [],
    //             serverProviderId: []
    //         })
    //     }

    // }
    if (prevState.products !== this.state.products) {
      let productId = this.state.products.find((item) => item.productId === this.state.taskObj.productId)
      if (productId) {
        this.setState({
          arrProductId: productId,
          serverProductId: productId
        })
      } else {
        this.setState({
          arrProductId: [],
          serverProductId: []
        })
      }
    }

    if (prevState.tasks !== this.state.tasks) {
      let findTask = this.state.tasks.find((item) => Number(item.id) === Number(this.state.taskId))
      // alert(JSON.stringify(findTask))
      if (findTask) {
        // alert(findTask.defaultCount)
        this.setState({
          // defaultCount : findTask.defaultCount,
          editableCount: findTask.editableCount ? 'true' : 'false'
        })
      }
    }
  }

  getValueProvider = (arrProviderId) => {
    if (arrProviderId === null) {
      this.setState({
        products: [],
        arrProviderId: []
      })
    } else {
      this.setState({
        arrProviderId
      })
      let id = arrProviderId

      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${id}`, {
          params: {
            sortByTitle: true
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            var products = response.data.object
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
  }

  getValueProduct = (arrProductId) => {
    if (arrProductId === null) {
      this.setState({
        arrProductId: []
      })
    } else {
      this.setState({
        arrProductId
      })
    }
  }
  validateMin = (evt) => {
    // if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
    // {
    //     evt.preventDefault();
    // }
  }
  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  epoch = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  editTask = () => {
    let {id} = this.props.match.params
    let {timeMinuteMax, timeMinuteMin, serverSectionId, serverTaskId, serverDepartmentId} = this.state
    let sectionId = document.getElementById('sectionId').value
    let taskId = document.getElementById('taskId').value
    let departmentId = document.getElementById('departmentId').value
    let timeMinuteUser = document.getElementById('timeMinuteUser').value
    let count = document.getElementById('count').value
    let description = document.getElementById('description').value.trim()
    let providerId = this.state.arrProviderId
    let serverProviderId =
      this.state.serverProviderId === '' ||
      this.state.serverProviderId === null ||
      this.state.serverProviderId.length === 0
        ? ''
        : this.state.serverProviderId.providerId
    let productId =
      this.state.arrProductId === '' || this.state.arrProductId === null || this.state.arrProductId.length === 0
        ? ''
        : this.state.arrProductId.productId
    let serverProductId =
      this.state.serverProductId === '' ||
      this.state.serverProductId === null ||
      this.state.serverProductId.length === 0
        ? ''
        : this.state.serverProductId.productId
    let activityDate = document.getElementById('activityDate').value
    let nowDate = Number(this.convertDigit(jMoment().format('jYYYYjMMjDD')))
    let numberActivitiDate = Number(this.convertDigit(jMoment(this.epoch(activityDate)).format('jYYYYjMMjDD')))

    let formErr = false
    let {needProduct, needProvider} = this.state
    if (
      needProvider === 'force' &&
      (sectionId === '' ||
        departmentId === '' ||
        taskId === '' ||
        timeMinuteUser === '' ||
        count === '' ||
        !providerId ||
        activityDate === '')
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (
      needProduct === 'force' &&
      (sectionId === '' ||
        departmentId === '' ||
        taskId === '' ||
        timeMinuteUser === '' ||
        count === '' ||
        productId === '' ||
        activityDate === '')
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (
      sectionId === '' ||
      taskId === '' ||
      departmentId === '' ||
      timeMinuteUser === '' ||
      count === '' ||
      activityDate === ''
    ) {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (this.epoch(activityDate) === undefined) {
      message.error('تاریخ وارد شده معتبر نیست')
    } else if (numberActivitiDate > nowDate) {
      message.error('حداکثر تاریخ وارد شده باید امروز باشد')
    }
    // else if(timeMinuteUser > timeMinuteMax * count){
    //     if(window.confirm('زمان وارد شده متعارف نیست.آیا ادامه میدهید؟؟')){
    //         let data = {
    //             departmentId,
    //             id,
    //             sectionId,
    //             taskId,
    //             timeMinuteUser,
    //             count,
    //             description,
    //             productId,
    //             providerId,
    //             activityDate : this.epoch(activityDate)
    //         }
    //         http.post(`${TMS.TMS_USER_ACTIVITY_UPDATE}`,data,{
    //
    //         }).then(response=>{
    //             if(response.data.error === null){
    //                 message.success('فعالیت با موفقیت ویرایش شد.لطفا صبر کنید')
    //                 setTimeout(()=>{
    //                     window.location.assign('/tms/task/report')
    //
    //                 },1500)
    //             }
    //         })
    //     }
    // }
    else {
      let data = {
        id,
        sectionId,
        taskId,
        timeMinuteUser,
        count,
        description,
        productId: this.state.needProduct === 'prevent' ? null : productId,
        providerId: this.state.needProvider === 'prevent' ? null : providerId,
        activityDate: this.epoch(activityDate),
        departmentId
      }
      http.post(`${TMS.TMS_USER_ACTIVITY_UPDATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('فعالیت با موفقیت ویرایش شد.لطفا صبر کنید')
          setTimeout(() => {
            window.location.assign('/tms/task/report')
          }, 1500)
        }
      })

      // if((Number(serverDepartmentId) === Number(departmentId)) && (Number(serverSectionId) === Number(sectionId)) && (Number(serverTaskId) === Number(taskId)) &&
      //     (Number(serverProviderId) === Number(providerId)) && ((serverProductId) === (productId))
      // ){
      //     let data = {
      //         id,sectionId,taskId,timeMinuteUser,count,description,productId,providerId,activityDate : this.epoch(activityDate),departmentId
      //     }
      //     http.post(`${TMS.TMS_USER_ACTIVITY_UPDATE}`,data,{
      //
      //     }).then(response=>{
      //         if(response.data.error === null){
      //             message.success('فعالیت با موفقیت ویرایش شد.لطفا صبر کنید')
      //             setTimeout(()=>{
      //                 window.location.assign('/tms/task/report')
      //
      //             },1500)
      //         }
      //     })
      // }
      // else{
      //     let data = {
      //         id,sectionId,taskId,timeMinuteUser,count,description,productId,providerId,activityDate : this.epoch(activityDate),departmentId
      //     }
      //     http.post(`${TMS.TMS_USER_ACTIVITY_UPDATE}`,data,{
      //
      //     }).then(response=>{
      //         if(response.data.error === null){
      //             message.success('فعالیت با موفقیت ویرایش شد.لطفا صبر کنید')
      //             setTimeout(()=>{
      //                 window.location.assign('/tms/task/report')
      //
      //             },1500)
      //         }
      //     })
      // }
      //     let duplicateData = {
      //         departmentId,
      //         sectionId,
      //         taskId,
      //         providerId: providerId === '' ? null : providerId,
      //         productId: productId === '' ? null : productId
      //     }
      //     http.post(`${TMS.TMS_USER_ACTIVITY_EXIST}`,duplicateData,{
      //
      //     }).then(res => {
      //         if(res.data.error === null){
      //             if(res.data.object){
      //                 if(window.confirm('این یک فعالیت تکراری است.آیا از ویرایش آن اطمینان دارید؟؟')){
      //                     let data = {
      //                         id,sectionId,taskId,timeMinuteUser,count,description,productId,providerId,activityDate : this.epoch(activityDate),departmentId
      //                     }
      //                     http.post(`${TMS.TMS_USER_ACTIVITY_UPDATE}`,data,{
      //
      //                     }).then(response=>{
      //                         if(response.data.error === null){
      //                             message.success('فعالیت با موفقیت ویرایش شد.لطفا صبر کنید')
      //                             setTimeout(()=>{
      //                                 window.location.assign('/tms/task/report')
      //
      //                             },1500)
      //                         }
      //                     })
      //                 }
      //             }
      //             else{
      //                 let data = {
      //                     id,sectionId,taskId,timeMinuteUser,count,description,productId,providerId,activityDate : this.epoch(activityDate),departmentId
      //                 }
      //                 http.post(`${TMS.TMS_USER_ACTIVITY_UPDATE}`,data,{
      //
      //                 }).then(response=>{
      //                     if(response.data.error === null){
      //                         message.success('فعالیت با موفقیت ویرایش شد.لطفا صبر کنید')
      //                         setTimeout(()=>{
      //                             window.location.assign('/tms/task/report')
      //
      //                         },1500)
      //                     }
      //                 })
      //             }
      //         }
      //         else{
      //             message.error(res.data.description)
      //         }
      //     })
      // }
    }
  }
  changeDescription(e) {
    let value = e.target.value
    let name = e.target.name
    this.setState({
      [name]: value
    })
  }
  onChange(e) {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }

  changeCount = (e) => {
    this.setState({
      defaultCount: e.target.value
    })
  }

  beforeMaskedValueChangeFrom = (newState, oldState, userInput) => {
    var {value} = newState
    var selection = newState.selection
    var cursorPosition = selection ? selection.start : null

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--
        selection = {start: cursorPosition, end: cursorPosition}
      }
      value = value.slice(0, -1)
    }

    return {
      value,
      selection
    }
  }

  render() {
    return (
      <div className={'rtl'}>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت وظایف</li>
            <li>ویرایش فعالیت</li>
          </ul>
          <MDBContainer fluid className="mt-4 bg-white pb-2">
            <MDBRow>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان<span className="requireFiled">*</span>
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeOrg.bind(this)}
                    name="departmentId"
                    id="departmentId"
                  >
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option
                        value={item.id}
                        selected={this.state.taskObj.departmentId === Number(item.id) ? true : false}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    بخش<span className="requireFiled">*</span>
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeSec.bind(this)}
                    name="sectionId"
                    id="sectionId"
                  >
                    <option value="">------</option>
                    {this.state.sections.map((item, index) => (
                      <option value={item.id} selected={this.state.taskObj.sectionId === item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    فعالیت<span className="requireFiled">*</span>
                  </label>
                  <select className="custom-select" onChange={this.changeTaskType.bind(this)} name="taskId" id="taskId">
                    <option value="">------</option>
                    {this.state.tasks.map((item, index) => (
                      <option
                        selected={this.state.taskObj.taskId === item.id}
                        data-timeMinuteMin={item.timeMinuteMin}
                        data-timeMinuteMax={item.timeMinuteMax}
                        data-needProduct={this.translateNeedProviderAndProduct(item.needProduct)}
                        data-needProvider={this.translateNeedProviderAndProduct(item.needProvider)}
                        data-editableCount={item.editableCount ? 'true' : 'false'}
                        data-defaultCount={item.defaultCount}
                        value={item.id}
                        key={index}
                      >
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
              {this.state.needProvider !== 'prevent' && !this.state.init ? (
                <MDBCol xs={12} sm={6} md={3}>
                  <div className="formComponent selectComponent">
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      extraFilter={{id: this.state.arrProviderId}}
                      required={this.state.needProvider === 'force' ? true : false}
                      value={this.state.arrProviderId}
                      setValue={this.getValueProvider}
                    />
                    {/* <label className={'font-weight-bold'}>تامین کننده{this.state.needProvider === 'force' ? <span className='requireFiled'>*</span> : ''}</label>
                                        <Select
                                            options={this.state.providers}
                                            isClearable={true}
                                            placeholder={'------'}
                                            value={this.state.arrProviderId}
                                            onChange={this.getValueProvider}
                                        /> */}
                  </div>
                </MDBCol>
              ) : null}
              {this.state.needProduct !== 'prevent' ? (
                <MDBCol xs={12} sm={6} md={3}>
                  <div className="formComponent">
                    <label className={'font-weight-bold'}>
                      {'کالا'}
                      {this.state.needProduct === 'force' ? <span className="requireFiled">*</span> : ''}
                    </label>
                    <Select
                      options={this.state.products}
                      isClearable={true}
                      placeholder={'------'}
                      value={this.state.arrProductId}
                      onChange={this.getValueProduct}
                    />
                  </div>
                </MDBCol>
              ) : null}
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    تاریخ<span className="requireFiled">*</span>
                  </label>
                  <InputMask
                    onChange={this.onChange.bind(this)}
                    placeholder="yyyy/mm/dd"
                    id="activityDate"
                    name="activityDate"
                    value={this.state.activityDate}
                    className="form-control"
                    mask="9999/99/99"
                    maskChar={null}
                    beforeMaskedValueChange={this.beforeMaskedValueChangeFrom}
                  />
                  {/*<SinglePicker*/}
                  {/*label ='تاریخ'*/}
                  {/*id = 'picker'*/}
                  {/*force*/}
                  {/*defaulValue={this.state.activityDate}*/}
                  {/*changeDate={this.changeActivityDate}*/}
                  {/*/>*/}
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold">
                    زمان (دقیقه)<span className="requireFiled">*</span>
                  </label>
                  <input
                    type="number"
                    defaultValue={
                      this.state.taskObj.timeMinuteUser && this.convertCount(this.state.taskObj.timeMinuteUser)
                    }
                    className="form-control"
                    min={1}
                    onKeyPress={this.validateMin.bind(this)}
                    id="timeMinuteUser"
                  />
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <label className="font-weight-bold">
                    تعداد<span className="requireFiled">*</span>
                  </label>
                  <input
                    type="number"
                    defaultValue={this.state.defaultCount}
                    disabled={this.state.editableCount === 'true' ? false : true}
                    onChange={this.changeCount}
                    className="form-control"
                    onKeyPress={this.validateMin.bind(this)}
                    id="count"
                  />
                </div>
              </MDBCol>

              <MDBCol xs={12}>
                <div className="formComponent">
                  <label className="font-weight-bold">توضیحات</label>
                  <textarea
                    id="description"
                    defaultValue={this.state.description}
                    onChange={this.changeDescription.bind(this)}
                    value={this.state.description}
                    name="description"
                    className="form-control"
                  />
                </div>
              </MDBCol>
              <MDBCol xs={12} sm={6} md={3}>
                <div className="formComponent">
                  <button
                    className="btn btn-block"
                    style={{background: '#b2d234', fontSize: '1.2em'}}
                    onClick={this.editTask}
                  >
                    ثبت
                  </button>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </div>
      </div>
    )
  }
}

export default withRouter(EditTask)
